// Bill figures render to two decimals so a total carrying GST paise still adds up on
// screen against its own lines: 5% of ₹350 is ₹17.50, and rounding each line to whole
// rupees produced a bill whose parts did not sum to its total.
//
// Menu browsing prices are deliberately NOT put through this. menu_items.price is an
// integer in the schema, so a menu card showing "₹350.00" would be adding precision that
// cannot exist. A menu is not a bill.
export const formatMoney = (amount) =>
    (Number(amount) || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
